import product_25 from '../assets/product_25.png'
import product_26 from '../assets/product_26.png'
import product_27 from '../assets/product_27.png'
import product_28 from '../assets/product_28.png'
import product_29 from '../assets/product_29.png'
const TopCollectionsData = [
  {
    id: 1,
    name: "Catherin Thresa",
    occupation: "Software Engineer",
    imageSrc: product_25,
    backgroundImage: product_25,
    description: "Passionate software engineer with expertise in full-stack web development. Dedicated to creating efficient and scalable solutions to complex problems.",
    followers: "750k",
    following: "200",
    likes: "3.5M"
  },
  {
    id: 2,
    name: "Jack Sparrow",
    occupation: "Police Detective",
    imageSrc: product_26,
    backgroundImage: product_26,
    description: "Experienced police detective with a strong track record of solving high-profile cases. Committed to upholding justice and protecting the community.",
    followers: "2M",
    following: "150",
    likes: "8M"
  },
  {
    id: 3,
    name: "Jenny Smith",
    occupation: "Travel Blogger",
    imageSrc: product_28,
    backgroundImage: product_28,
    description: "Passionate traveler and blogger exploring the world's most captivating destinations. Sharing stories and tips to inspire others to embark on their own adventures.",
    followers: "1.5M",
    following: "50",
    likes: "7M"
  },
  {
    id: 4,
    name: "Michael Johnson",
    occupation: "App Developer",
    imageSrc: product_29,
    backgroundImage: product_29,
    description: "Innovative app developer specializing in creating user-friendly mobile applications that enhance productivity and enrich lives. Committed to staying updated with the latest technologies.",
    followers: "1.2M",
    following: "80",
    likes: "6.5M"
  },
  {
    id: 5,
    name: "Emma Watson",
    occupation: "Actress",
    imageSrc: product_25,
    backgroundImage: product_25,
    description: "Talented actress known for her roles in blockbuster films and dedication to social and environmental causes. Committed to using her platform to advocate for positive change.",
    followers: "12M",
    following: "120",
    likes: "25M"
  },
  {
    id: 6,
    name: "John Doe",
    occupation: "Chef",
    imageSrc: product_26,
    backgroundImage: product_26,
    description: "Renowned chef with a passion for creating exquisite culinary experiences. Known for innovative techniques and dedication to using fresh, locally-sourced ingredients.",
    followers: "550k",
    following: "190",
    likes: "9M"
  }
];

export default TopCollectionsData;
